import {getCurrentPortalProp} from '@netx/core-cms-next/utils/getCurrentPortalProp';
import {isPublicUser} from '../utils/isPublicUser';

export const canLoginPublicAccess = () => {
	return (
		getCurrentPortalProp('requireLogin') === false &&
		getCurrentPortalProp('enableSignIn') === true &&
		isPublicUser()
	);
};
